import {FC} from 'react';
import {RegularModal} from 'modules/modals/components/RegularModal';
import style from './style.module.scss';
import {Button} from 'components/Button';
import Picture from 'components/Picture';
import {
    BUY_CERTIFICATE_BUTTON_TEXT,
    CERTIFICATE_RULES,
    MODAL_TITLE,
    TASTING_CERTIFICATE_BUTTON_LINK_HREF,
    TASTING_CERTIFICATE_IMAGE,
} from 'modules/events/components/BannerCertificateModal/constants';

export const TastingCertificateInfoModal: FC = () => {
    return (
        <RegularModal
            hasClose={true}
            title={MODAL_TITLE}
            className={style.root}
            classNameTitle={style.title}
            classNameContent={style.classNameContent}
            isMobileBottomAlign={true}
        >
            <div>
                <Picture src={TASTING_CERTIFICATE_IMAGE} className={style.certificateImage} />
                <ul className={style.content}>
                    {CERTIFICATE_RULES.map((rule, index) => (
                        <li key={index}>{rule}</li>
                    ))}
                </ul>
                <div className={style.buttonWrapper}>
                    <Button href={TASTING_CERTIFICATE_BUTTON_LINK_HREF} className={style.button}>
                        {BUY_CERTIFICATE_BUTTON_TEXT}
                    </Button>
                </div>
            </div>
        </RegularModal>
    );
};
